<template>
  <div class="asc-issue-investigation-container">
    <template v-if="!isMaintenanceRecPageActive">
      <asc-page-coming-soon label="Maintenance Rec Page Coming Soon!" />
    </template>

    <template v-else-if="issueId === -1">
      <asc-page-loading-indicator :loading="true"></asc-page-loading-indicator>
    </template>

    <template v-else>
      <asc-page-loading-indicator
        :loading="isDataLoading && !apiPageFailure.length"
      >
        <v-container class="asc-issue-investigation-wrapper pa-4" fluid>
          <v-row v-if="definition.length" dense>
            <v-col>
              <asc-notification
                :definition="definition"
                @onLinkClick="handleViewMxRecAction"
              />
            </v-col>
          </v-row>

          <v-row dense>
            <v-col cols="12">
              <asc-mx-rec-header-wrapper
                :issue-id="issueId"
                :disable-save="saveDisabled || reEntrantLock"
                :is-sticky="isSticky"
                :save-loading="isSaveLoading"
                :is-custom-alert="isCustomAlert"
                :is-chronic-repeaters="isChronicRepeaters"
                @onSave="handleInvestigationChanges"
                @onCancel="handleCancelChanges"
              />
            </v-col>
          </v-row>

          <v-row dense>
            <v-col cols="12">
              <asc-card
                v-if="
                  (isEditPermissionInvestigate ||
                    isReadOnlyPermissionInvestigate) &&
                  !isCustomAlert &&
                  !isChronicRepeaters
                "
                class="asc-issue-investigation-container__card"
                no-spacing
                flat
              >
                <v-container class="pa-0" fluid>
                  <v-row no-gutters>
                    <v-col md="6" sm="8">
                      <asc-tab v-model="model">
                        <asc-tab-title title="Investigate" />
                        <asc-tab-title title="MX Recommendation" />
                      </asc-tab>
                    </v-col>
                    <v-col class="updatedDate pa-1 pr-4" md="6" sm="4">
                      Last Updated: {{ lastUpdatedBy }}
                    </v-col>
                  </v-row>
                </v-container>
              </asc-card>
              <asc-tab-body :value="model">
                <asc-tab-item>
                  <asc-mx-rec-investigate-template
                    v-model="changesMade"
                    :issue-id="issueId"
                    :save-disabled="saveDisabled"
                    :aircraft-details="getMxRec"
                    :is-plot-data-loading="isPlotDataLoading"
                    :page-plots="getPagePlots"
                    :are-plots-editable="arePlotsEditable"
                    :loading-plot-ids="loadingPlotIds"
                    :on-apply-page-plot="loadPlotData"
                    :aircraft-details-loading="isAircraftDetailsDataLoading"
                    :chart-data="getChartData"
                    :is-pre-submittal="calculatePreSubmittal()"
                    :file-types="attachmentTypes"
                    :save-loading="isSaveLoading"
                    :status-options="getStatusOptions"
                    :locked-status-options="getLockedStatusOptions"
                    :details-discussion-type-id="detailsDiscussionTypeID"
                    :investigation-discussion-type-id="
                      investigationDiscussionTypeID
                    "
                    :details-discussion="mxRec.detailsDiscussion"
                    :details-status-updates="mxRec.statusUpdates"
                    :investigation-discussion="mxRec.investigationDiscussion"
                    :airline-tier-type-id="airlineTierTypeId"
                    :user="profile"
                    :investigation-users-to-tag="investigatorUsers"
                    :reset-investigation-comment="resetInvestigationComment"
                    :reset-details-comment="resetDetailsComment"
                    :restore-discussions="restoreDiscussions"
                    :details-users-to-tag="detailDiscussionUsers"
                    :flight-sense-upload-error="flightSenseUploadError"
                    :mx-action-attachment-upload-error="
                      mxActionAttachmentUploadError
                    "
                    :support-attachment-upload-error="
                      supportAttachmentUploadError
                    "
                    :re-entrant-lock-obtained="reEntrantLock"
                    :supporting-info-selection-types="
                      supportingInfoSelectionTypes
                    "
                    :is-plot-deletion-successful="isPlotDeletionSuccessful"
                    :severity-options="severityOptions"
                    :fix-effectiveness-options="fixEffectivenessOptions"
                    :service-delivery-outcome-options="
                      serviceDeliveryOutcomeOptions
                    "
                    :analytic-detection-outcome-options="
                      analyticDetectionOutcomeOptions
                    "
                    :reason-to-close-options="reasonToCloseOptions"
                    :airline-response-options="airlineResponseOptions"
                    :related-alerts="mappedRelatedAlerts"
                    :is-manually-created="isManuallyCreated"
                    :hide-hidden-tabs="hideHiddenTabs"
                    :on-toggle-page-plot-visibility="
                      handleTogglePagePlotVisibility
                    "
                    :is-support-info-loading="isSupportInfoLoading"
                    :is-details-discussion-loading="isDetailsDiscussionLoading"
                    :is-investigation-discussion-loading="
                      isInvestigationDiscussionLoading
                    "
                    :is-custom-alert="isCustomAlert"
                    :is-chronic-repeaters="isChronicRepeaters"
                    :custom-alert-mx-rec-status-options="
                      getCustomAlertStatusOptions
                    "
                    :tab-index="getCurrentIssueTabIndex"
                    :mx-rec-details-form-fields="mxRecDetailsFormFields"
                    :mx-rec-title-form-fields="mxRecTitleFormFields"
                    :is-disable-submit="getDisableSubmit"
                    :status-info="getStatusInfo"
                    :on-update-page-plot-caption="handleUpdatePagePlotCaption"
                    :on-expand="handleExpand"
                    :on-add-tab-to-page-plot="handleAddTabToPagePlot"
                    :on-remove-tab-from-page-plot="handleRemoveTabFromPagePlot"
                    :on-update-tab-view-page-plot="handleUpdateTabViewPagePlot"
                    @newComment="handleNewComment"
                    @isSaveDisabled="handleIsSaveDisabled"
                    @addUserComment="handleNewComment"
                    @deleteUserComment="handleCommentRemoval"
                    @removeUnsavedComment="handleRemoveUnsavedComment"
                    @downloadFile="handleDownloadFile"
                    @updateUserComment="handleUpdateComment"
                    @fileUpdate="handleMxRecFiles"
                    @onRemovePlot="handleRemovePlot"
                    @onPlotVisibility="handlePlotVisibility"
                    @reEntrantLock="handleReEntrantLock"
                    @rowSelected="handleRowSelected"
                    @updateMxRecommendation="handleUpdateMxRecRecommendation"
                    @updateCaption="handleUpdateCaption"
                    @updateMxRecAlertDetails="handleUpdateMxRecAlertDetails"
                    @updateMxRecStatusDetails="handleUpdateMxRecStatusDetails"
                    @updateMxRecStatusId="handleUpdateMxRecStatusID"
                    @updateMxRecValidationDetails="
                      handleUpdateMxRecValidationDetails
                    "
                    @updateMxRecConcludeDetails="
                      handleUpdateMxRecConcludeDetails
                    "
                    @updateMxRecFollowUpFields="handleUpdateMxRecFollowUpFields"
                    @updateAttachmentCaption="handleUpdateAttachmentCaption"
                    @updateMxRecTitle="handleUpdateMxRecTitle"
                    @onAlert="manageAlerts"
                    @followUpDataChanges="hasFollowUpDataChanges"
                    @hasData="hasData"
                /></asc-tab-item>
                <asc-tab-item>
                  <asc-mx-rec-recommendation-template
                    v-model="changesMade"
                    :issue-id="issueId"
                    :user="profile"
                    :aircraft-details="getMxRec"
                    :is-pwc-user="isPwcUser"
                    :is-pre-submittal="calculatePreSubmittal()"
                    :details-discussion-type-id="detailsDiscussionTypeID"
                    :details-discussion="mxRec.detailsDiscussion"
                    :details-status-updates="mxRec.statusUpdates"
                    :airline-tier-type-id="airlineTierTypeId"
                    :status-options="getStatusOptions"
                    :reset-details-comment="resetRecommendationDetailsComment"
                    :locked-status-options="getLockedStatusOptions"
                    :restore-discussions="restoreDiscussions"
                    :details-users-to-tag="detailDiscussionUsers"
                    :is-details-discussion-loading="isDetailsDiscussionLoading"
                    :is-custom-alert="isCustomAlert"
                    :is-chronic-repeaters="isChronicRepeaters"
                    :repeater-id="mxRec.chronicRepeaterUniqueId"
                    :related-alerts-loading="relatedAlertsLoading"
                    :related-alerts="mappedRelatedAlerts"
                    :issue-source="issueSource"
                    :is-investigation-tab="!isRecommendationTab"
                    :is-recommendation-tab="isRecommendationTab"
                    :is-manually-created="isManuallyCreated"
                    :tab-index="getCurrentIssueTabIndex"
                    :is-disable-submit="getDisableSubmit"
                    :file-types="attachmentTypes"
                    :mx-rec-details-form-fields="mxRecDetailsFormFields"
                    :mx-action-attachment-upload-error="
                      mxActionAttachmentUploadError
                    "
                    :plotly-data="plotlyTokens"
                    :custom-alert-mx-rec-status-options="
                      getCustomAlertStatusOptions
                    "
                    :re-render-plotly="reRenderPlotly"
                    :is-upcoming-flights-loading="upcomingFlightsLoading"
                    :flight-aware-last-updated-date="flightAwareLastUpdatedDate"
                    :future-flight-schedules="futureFlightSchedules"
                    :is-plotly-dirty="isPlotlyDirty"
                    :re-entrant-lock-obtained="reEntrantLock"
                    :severity-options="severityOptions"
                    @downloadFile="handleDownloadFile"
                    @fileUpdate="handleMxRecFiles"
                    @isSaveDisabled="handleIsSaveDisabled"
                    @updateMxRecFollowUpFields="handleUpdateMxRecFollowUpFields"
                    @addUserComment="handleNewComment"
                    @onPostClick="handleDetailDiscussionPostClick"
                    @followUpDataChanges="hasFollowUpDataChanges"
                    @deleteUserComment="handleDiscussionCommentRemoval"
                    @removeUnsavedComment="handleRemoveUnsavedComment"
                    @updateUserComment="handleDiscussionCommentUpdate"
                    @changeInvestigation="handleInvestigationChanges"
                    @updateMxRecStatusId="handleUpdateMxRecStatusID"
                    @hasData="isPostData"
                    @commentText="getCommentText"
                    @onRelatedEventGridChange="handleRelatedEventGridChange"
                    @onIssueCreation="handleOnIssueCreation"
                    @onRepeaterRelatedEventGridChange="
                      handleRepeaterRelatedEventGridChange
                    "
                    @updateMxRecAlertDetails="handleUpdateMxRecAlertDetails"
                  />
                </asc-tab-item>
              </asc-tab-body>
            </v-col>
          </v-row>

          <asc-mx-rec-dialog
            :is-confirmation="isConfirmation"
            :changes-made="changesMade"
            :show-dialog="showConfirmationDialog"
            :on-save-exit-session="handleUserSaveOnExit"
            :on-continue-session="handleUserRenew"
            :on-exit-without-saving-session="handleExitWithoutSaving"
            :has-data="hasData"
            :is-plotly-dirty="isPlotlyDirty"
            :follow-up-data-changes="followUpDataChanges"
            :status-id-updated="statusIdUpdated"
            :attachment-added="attachmentAdded"
          />

          <asc-mx-rec-confirm-submit-dialog
            :show-dialog="mxRecConfirmSubmitDialogVisibility"
            :on-accept="handleUserConfirmation"
            :on-close="handleSubmitConfirmDialogClose"
            :is-post-submittal-status="isPostSubmittalStatus"
          />

          <asc-confirmation
            v-if="showDeleteSupportingPlotConfirmToast"
            :definition="deleteSupportingPlotToastDefinition"
            :on-close="handleDeleteSupportingPlotToastClose"
            :on-toast-action="handleUndoDeleteSupportingPlot"
          />

          <asc-confirmation
            v-if="showDeleteSupportingAttachmentsConfirmToast"
            :definition="deleteSupportingAttachmentsToastDefinition"
            :on-close="handleDeleteSupportingAttachmentsToastClose"
            :on-toast-action="handleUndoDeleteSupportingAttachments"
          />

          <asc-page-plot-dialog
            :page-plot="expandedPagePlot"
            :loading-plot-ids="loadingPlotIds"
            :chart-data="chartData"
            :filter-lookups="filterLookups"
            :editable="arePlotsEditable"
            :saving="isPlotSaving"
            :on-close="handlePagePlotDialogClose"
            :show-dialog="pagePlotDialogVisible"
            :on-apply-page-plot="handleRefreshData"
            :on-add-tab-to-page-plot="handleAddTabToPagePlot"
            :on-remove-tab-from-page-plot="handleRemoveTabFromPagePlot"
            :on-save-page-plot="handleSavePagePlot"
            :on-update-page-plot-caption="handleUpdatePagePlotCaption"
            :on-update-tab-view-page-plot="handleUpdateTabViewPagePlot"
            :hide-hidden-tabs="hideHiddenTabs"
            :is-tab-menu-disabled="isTabMenuDisabled"
          />
        </v-container>
      </asc-page-loading-indicator>
    </template>
  </div>
</template>

<script>
import AscPageComingSoon from '../../../molecules/AscPageComingSoon.vue'
import AscMxRecDialog from '../../../molecules/AscMxRecDialog.vue'
import AscPageLoadingIndicator from '../../../molecules/AscPageLoadingIndicator.vue'
import AscPagePlotDialog from '../../../molecules/AscPagePlotDialog.vue'
import AscMxRecConfirmSubmitDialog from '../../../molecules/AscMxRecConfirmSubmitDialog.vue'
import AscConfirmation from '../../../molecules/AscConfirmation.vue'
import AscNotification from '../../../molecules/AscNotification.vue'

import AscMxRecInvestigateTemplate from '../../../templates/AscMxRecInvestigateTemplate.vue'
import AscMxRecRecommendationTemplate from '../../../templates/AscMxRecRecommendationTemplate.vue'

import AscMxRecPlotsMixin from '../../../mixins/AscMxRecPlotsMixin.vue'
import AscMxRecPermissionMixin from '../../../mixins/AscMxRecPermissionMixin.vue'
import AscMxRecHeaderWrapper from '../../../organisms/AscMxRecHeaderWrapper.vue'

import AscCard from '@/components/atoms/AscCard'
import AscTab from '@/components/atoms/AscTab'
import AscTabBody from '@/components/atoms/AscTabBody'
import AscTabItem from '@/components/atoms/AscTabItem'
import AscTabTitle from '@/components/atoms/AscTabTitle'

import _isEqual from 'lodash/isEqual'
import _sortBy from 'lodash/sortBy'

import { mapActions, mapGetters, mapState, mapMutations } from 'vuex'
// import { provide } from 'vue'
import {
  ATTACHMENT_CONSTS as AC,
  MAINTENANCE_ISSUES_CONSTS as MIC,
  FLIGHTAWARE_CONSTS as FAC,
  USER_CONSTS as UC,
  PLOTLY_CONSTS as PLC,
} from '@/stores/consts'
import {
  COLLINS_PHM_TIER_3,
  CUSTOM_ALERT_SOURCE_ID,
  CHRONIC_REPEATERS_SOURCE_ID,
  PWC_PHM_TIER_0,
  COLLINS_PHM_TIER_4,
  REPEATER_MANUAL,
} from '@/utilities/appConsts'
import moment from 'moment'

// FEATURE FLAG
import AppFeatureFlags from '@/utilities/appFeatureFlags'

export default {
  name: 'AscMxRecContainer',

  components: {
    AscCard,
    AscTab,
    AscTabBody,
    AscTabItem,
    AscTabTitle,
    AscNotification,
    AscPageComingSoon,
    AscMxRecDialog,
    AscPageLoadingIndicator,
    AscMxRecHeaderWrapper,
    AscMxRecInvestigateTemplate,
    AscMxRecRecommendationTemplate,
    AscMxRecConfirmSubmitDialog,
    AscConfirmation,
    AscPagePlotDialog,
  },

  mixins: [AscMxRecPlotsMixin, AscMxRecPermissionMixin],

  beforeRouteLeave(to, from, next) {
    if (
      (this.changesMade ||
        this.isPlotlyDirty ||
        this.followUpDataChanges ||
        this.statusIdUpdated ||
        this.attachmentAdded ||
        this.severityIdUpdated ||
        this.hasData) &&
      !this.timeIsUp
    ) {
      this.$nextTick(() => {
        this.isConfirmation = true
        this.showConfirmationDialog = true
      })
      this.routePath = to
    } else {
      // No changes were made so a user can leave
      //  If The issue is locked then relase it
      if (this.reEntrantLockObtained) this.handleReEntrantLock(false)
      next()
    }
  },

  beforeRouteUpdate(to, from, next) {
    if (this.changesMade && !this.timeIsUp) {
      this.$nextTick(() => {
        this.isConfirmation = true
        this.showConfirmationDialog = true
      })
      this.routePath = to
    } else {
      if (this.reEntrantLockObtained) this.handleReEntrantLock(false)
      next()
    }
  },

  props: {
    issueId: {
      type: Number,
      required: true,
    },
  },

  // setup() {
  //  provide('isEditInvestigate', this.isEditPermissionInvestigate)
  // },

  data() {
    return {
      definition: [],
      saveDisabled: true,
      issueTabIndex: 0,
      isRecommendationTab: false,
      // Initial data loading values
      attachmentsLoading: false,
      faultMessagesLoading: false,
      upcomingFlightsLoading: false,
      isAircraftDetailsDataLoading: false,
      issueSource: false,
      isDiscussionTypesLoading: false,
      isStatusDataLoading: false,
      phmAlertsLoading: false,
      userSelectionsLoading: false,
      relatedAlertsLoading: false,
      attachmentToDelete: null,
      changesMade: false,
      forceSave: false,
      isConfirmation: false,
      isInternalView: false,
      isSaveLoading: false,
      isSticky: false,
      isSubmitting: false,
      mxRecConfirmSubmitDialogVisibility: false,
      mxRecDetails: null,
      routePath: null,
      sessionTimer: null,
      showConfirmationDialog: false,
      timeIsUp: false,
      warningTimer: null,
      undoAttachmentRemoval: false,
      user: {},
      userConfirmation: false,
      userList: [],
      reEntrantLockObtained: null,
      isPostSubmittalStatus: false,
      resetInvestigationComment: false,
      resetDetailsComment: false,
      resetRecommendationDetailsComment: false,
      restoreDiscussions: false,
      isOnRecommendationTab: false,
      airlineTierTypeId: null,
      statusId: null,
      hasData: false,
      followUpDataChanges: false,
      statusIdUpdated: false,
      severityIdUpdated: false,
      attachmentAdded: false,
      postComment: null,
      reRenderPlotly: false,
      isPlotlyDirty: false,
      newInvestigationComment: null,
      newDetailsComment: null,
      lockedBy: null,
      deleteSupportingAttachmentsToastDefinition: [
        {
          mode: 'toast',
          type: 'warning',
          text: 'Attachment deleted',
          position: 'bottom',
          dismissible: false,
          hasToastAction: false,
          autoClose: true,
          icon: 'mdi-delete',
          duration: 8000,
        },
      ],
      repeaterId: this.$route.query.repeaterId,
      isIssueCreationInprogres: false,
    }
  },

  computed: {
    isFeatureInvestigator() {
      return this.isReadPermissionFeatureInvestigation
    },
    ...mapGetters(MIC.NAMESPACE, ['manualMxRecSources']),
    ...mapGetters(UC.NAMESPACE, ['isAcmfUser', 'isAirlineUser', 'isPwcUser']),
    ...mapState({ apiPageFailure: 'apiPageFailure' }),
    ...mapState(MIC.NAMESPACE, [
      'mxRec',
      'detailsDiscussionTypeID',
      'severityOptions',
      'fixEffectivenessOptions',
      'serviceDeliveryOutcomeOptions',
      'analyticDetectionOutcomeOptions',
      'reasonToCloseOptions',
      'airlineResponseOptions',
      'investigationDiscussionTypeID',
      'supportingInfoSelectionTypes',
      'investigatorUsers',
      'maintenanceStatuses',
      'detailDiscussionUsers',
      'relatedAlerts',
      'customAlertMaintenanceIssueVersion',
      'preservedMxRec',
      'isDetailsDiscussionLoading',
      'isInvestigationDiscussionLoading',
    ]),
    ...mapState(UC.NAMESPACE, ['profile']),
    ...mapState(AC.NAMESPACE, [
      'attachmentTypes',
      'attachmentsToRemove',
      'attachmentsToUpdate',
      'uploadedAttachments',
      'uploadErrorByType',
    ]),
    ...mapState(PLC.NAMESPACE, ['dashSelections']),
    ...mapState(FAC.NAMESPACE, [
      'flightAwareLastUpdatedDate',
      'futureFlightSchedules',
    ]),
    model: {
      get() {
        if (
          this.isMxRecEditPermission ||
          this.isCustomAlert ||
          this.isChronicRepeaters
        ) {
          return 1
        } else {
          return this.issueTabIndex
        }
      },
      set(newVal) {
        this.issueTabIndex = newVal
        if (newVal === 0) {
          this.isRecommendationTab = false
        } else {
          this.isRecommendationTab = true
        }
      },
    },

    lastUpdatedBy() {
      // Add user's name once it is added to mx issue data
      const updatedByName = this.mxRec?.lastUpdatedBy
        ? `\u00A0 ${this.mxRec?.lastUpdatedBy}`
        : ''
      const updatedDate = this.mxRec?.updatedDate
        ? `, ${moment(this.mxRec?.updatedDate).format('hh:mm a, DD MMM YYYY')}`
        : ''
      return ` ${updatedByName} ${updatedDate}`
    },

    hideHiddenTabs() {
      return this.isMxRecEditPermission || this.isOnRecommendationTab
    },

    isCustomAlert() {
      return this.mxRec?.source.id
        ? this.mxRec?.source.id === CUSTOM_ALERT_SOURCE_ID
        : true
    },

    isChronicRepeaters() {
      return this.mxRec?.source.id
        ? this.mxRec?.source.id === CHRONIC_REPEATERS_SOURCE_ID ||
            this.mxRec?.source.id === REPEATER_MANUAL
        : false
    },

    isTabMenuDisabled() {
      return this.isMxRecEditPermission || this.isOnRecommendationTab
    },

    getMxRec() {
      return this.mxRec
    },

    isMxRecEditOnlyPermission() {
      return (
        !this.isEditPermissionInvestigate &&
        !this.isReadOnlyPermissionInvestigate &&
        this.isMxRecEditPermission
      )
    },

    isMaintenanceRecPageActive() {
      return AppFeatureFlags.getMaintenanceRecPage()
    },

    isDataLoading() {
      return (
        this.isAircraftDetailsDataLoading ||
        this.isDiscussionTypesLoading ||
        this.isDiscussionDataLoading ||
        this.isStatusDataLoading ||
        this.userSelectionsLoading ||
        this.relatedAlertsLoading ||
        this.isSupportInfoLoading ||
        // MxRecPlotsMixin
        this.isPlotSaving ||
        this.isPlotDeleting ||
        this.plotsLoading ||
        this.isIssueCreationInprogres
      )
    },

    isSupportInfoLoading() {
      return (
        this.attachmentsLoading ||
        this.phmAlertsLoading ||
        this.faultMessagesLoading ||
        this.isLookupDataLoading
      )
    },

    isPlotDataLoading() {
      return this.isLookupDataLoading || this.plotsLoading
    },

    isDiscussionDataLoading() {
      return (
        this.isDetailsDiscussionLoading || this.isInvestigationDiscussionLoading
      )
    },

    isManuallyCreated() {
      return (
        this.manualMxRecSources?.findIndex(
          source => source.value === this.mxRec?.source?.id,
        ) !== -1
      )
    },

    getCustomAlertStatusOptions() {
      return this.maintenanceStatuses.filter(
        item =>
          item.agreementTypeIds.indexOf(PWC_PHM_TIER_0) > -1 &&
          !item.isOnlyChronicRepeater,
      )
    },
    getStatusOptions() {
      // - isExternal:false = is a Presubmittal
      // - isExternal:true = Post-submittal
      // - isExternal:false and isTerminal:true = is internal but mxRec-Complete
      // - isExternal:true && isTerminal:true = is a post-submittal
      // - isTerminal:true = is a mxRec-Complete
      // - Previous Maintenance Rec Submitted( mxRecAvailable : true)  = New-MXRec === isExternal:true && isInitial:true
      const preservedStatus = this.maintenanceStatuses.find(
        item => item.id === this.preservedMxRec?.status?.id,
      )

      return this.maintenanceStatuses
        .filter(
          status =>
            status.agreementTypeIds.includes(this.airlineTierTypeId) &&
            (!status.isOnlyChronicRepeater ||
              (this.isChronicRepeaters && status.isChronicRepeater)),
        )
        ?.map((status, index) => {
          const isOptionEnabled =
            preservedStatus?.isExternal || !status.isExternal
          return {
            ...status,
            text: status.name,
            groupName: status.isExternal
              ? status.isTerminal
                ? 'closed'
                : 'airline'
              : 'preSubmittal', //FMT
            value: index,
            enabled: isOptionEnabled, //Enable option if its a post-submittal
            tooltip: !isOptionEnabled
              ? 'Mx Rec must be submitted in order to enable post-submittal statuses'
              : null,
          }
        })
    },

    getLockedStatusOptions() {
      const disabledStatuses = this.getStatusOptions.filter(statusObj => {
        return !statusObj.enabled
      })

      return disabledStatuses.map(statusObj => {
        return statusObj.value
      })
    },

    flightSenseUploadError() {
      return this.uploadErrorByType.flatMap(error => {
        if (error.type === 2) return error.files
        else return []
      })
    },

    mxActionAttachmentUploadError() {
      return this.uploadErrorByType.flatMap(error => {
        if (error.type === 1) return error.files
        else return []
      })
    },

    supportAttachmentUploadError() {
      return this.uploadErrorByType.flatMap(error => {
        if (error.type === 3) return error.files
        else return []
      })
    },

    parentElement() {
      return this.$parent.$el || window
    },

    reEntrantLock() {
      // Dont change this as there are 3 values true,false and null
      return this.reEntrantLockObtained === false
    },

    mxRecDetailsFormFields() {
      const mxRecDetails = this.mxRec.recommendation
        ? this.mxRec.recommendation
        : ''
      return {
        mxRecDetails: mxRecDetails,
        valid:
          mxRecDetails.replace(/\s/g, '') !== this.emptyComment &&
          mxRecDetails.replace(/\s/g, '') !== '',
      }
    },

    mxRecTitleFormFields() {
      const title = this.mxRec?.title ? this.mxRec?.title : ''

      return {
        title: title,
        valid: title.replace(/\s/g, '') !== '',
        dateSubmitted: this.mxRec?.dateSubmitted,
        createdDate: this.mxRec?.createdDate, // For tier 3 and custom alert source we wont have submitted date
      }
    },

    getStatusInfo() {
      return {
        statusId: this.statusId,
        ownerUserId: this.mxRec?.ownerUserId,
        personWhoSentMxRec: this.mxRec?.mxRecSubmitterId,
        assetSupportPOC: this.mxRec?.assetSupportPOC,
      }
    },

    getCurrentIssueTabIndex() {
      if (
        (this.isEditPermissionInvestigate ||
          this.isReadOnlyPermissionInvestigate) &&
        !this.isCustomAlert &&
        !this.isChronicRepeaters
      )
        return this.issueTabIndex
      else if (
        this.isMxRecEditPermission ||
        this.isCustomAlert ||
        this.isChronicRepeaters
      ) {
        return 1
      } else {
        return this.issueTabIndex
      }
    },

    isAirlineTier3OrTier4() {
      return this.airlineTierTypeId === COLLINS_PHM_TIER_3 || COLLINS_PHM_TIER_4
        ? true
        : false
    },

    getDisableSubmit() {
      const foundStatuses = this.getStatusOptions.find(
        status => status.id === this.statusId,
      )

      if (foundStatuses) {
        // if the current status is IsExternal true then its a post-submittal status.
        // So the submit button should be disabled.
        if (foundStatuses.isExternal) {
          return true
        } else {
          // for pre-submittal statuses, we need to disable submit
          // if recommendation is blank and the user hasn't saved
          return !(
            this.mxRecDetailsFormFields.valid &&
            this.mxRecTitleFormFields.valid &&
            this.saveDisabled
          )
        }
      } else {
        return true
      }
    },

    mappedRelatedAlerts() {
      if (this.isMxRecEditPermission || this.isRecommendationTab) {
        return this.relatedAlerts?.filter(
          item => item.issueId !== this.mxRec?.id && item.isExternal,
        )
      } else {
        return this.relatedAlerts?.filter(
          item => item.issueId !== this.mxRec?.id,
        )
      }
    },
  },

  watch: {
    uploadedAttachments(newValue) {
      this[AC.RESET_ATTACHMENT_ERRORS]()
      const attachmentsToAdd = []
      // whenver this changes, this serves to update the mx rec store with
      // attachments.  Since it sends the whole array each time, we need to
      // ONLY put in the new ones...not just the whole array, as that led
      // to duplicate values
      newValue.forEach(uploadedAttachmentObj => {
        const isAttachmentAlreadyThere = this.mxRec.attachments.filter(
          attachmentObj => {
            return attachmentObj.id === uploadedAttachmentObj.id
          },
        )
        if (!isAttachmentAlreadyThere.length) {
          attachmentsToAdd.push(uploadedAttachmentObj)
        }
      })
      this[MIC.UPDATE_MAINTENANCE_ATTACHMENTS]({
        add: true,
        attachments: attachmentsToAdd,
      })
    },

    'mxRec.status'(val) {
      if (val) {
        this.statusId = val.id
      }
    },

    isSaveLoading(newValue) {
      this.saveDisabled = !newValue
    },

    forceSave(newValue) {
      if (newValue) this.handleInvestigationChanges('save')
    },

    reEntrantLockObtained(status) {
      if (status === false) {
        this.saveDisabled = true
        this.manageAlerts({
          type: 'primary',
          icon: 'mdi-alert-circle',
          text: `${this.lockedBy} is editing this issue. This lockout will expire after ${this.lockedBy} exits this page.`,
          add: true,
        })
      } else {
        this.manageAlerts({
          type: 'primary',
          icon: 'mdi-alert-circle',
          text: `${this.lockedBy} is editing this issue. This lockout will expire after ${this.lockedBy} exits this page.`,
        })
      }
    },

    customAlertMaintenanceIssueVersion(newValue) {
      if (
        this.isCustomAlert &&
        newValue?.relatedCustomAlertIssueId !== undefined
      ) {
        let val = {
          color: 'primary',
          dismissible: false,
          isActive: true,
          mode: 'alert',
          type: 'standard',
          text:
            newValue?.oldVersion === true
              ? 'This maintenance recommendation was triggered within 30 days of a change in custom analytic logic.'
              : 'The analytic logic that generated this maintenance recommendation is no longer active. This page will not be updated',
          icon: 'mdi-information',
          uppercase: false,
          link:
            newValue?.relatedCustomAlertIssueId === null
              ? ''
              : newValue?.oldVersion === true
              ? 'View Related Mx Rec'
              : 'View New Mx Rec',
        }
        if (this.definition.find(f => f.link)) {
          let data = [...this.definition]
          let index = this.definition.findIndex(f => f.link)
          if (index > -1) {
            data[index] = val
            this.definition = data
          }
        } else {
          this.definition.unshift(val)
        }
      }
    },
  },

  async mounted() {
    this.parentElement.addEventListener('scroll', this.handlePageScroll, false)
    window.addEventListener('resize', this.handlePageResize)
    const noGlobalFilter = true
    if (this.isMaintenanceRecPageActive && this.issueId !== -1) {
      const timerEnabled = AppFeatureFlags.getEnableMxRecTimer()
      this.userTimer(timerEnabled)
      await this.callFilterLookups(noGlobalFilter)
      await this.getAircraftDetailsData()
      if (this.mxRec.airline !== undefined) {
        await this.loadTails(noGlobalFilter, this.mxRec.airline.id)
      }

      // get tire information
      if (this.mxRec.tail) {
        const selectedTail = this.mappedLuTailsAll.find(
          tail => tail.value === this.mxRec.tail.id,
        )

        this.airlineTierTypeId = selectedTail
          ? selectedTail.airlineTierTypeId
          : null
      }

      await Promise.all([
        this.getStatusData(),
        this.getAttachments(),
        this.getUpcomingFlightSchedules(),
        this.getMxRecDiscussions(),
        this.getMxRecStatusUpdates(),
        this.getRelatedAlerts(),
        this.getPhmAlerts(),
      ])

      // User Tagging
      if (this.isReadPermissionUserTagging) {
        await this.getUserListForDiscussion()
      }

      // MxRecPlotsMixin
      if (!this.isPwcUser) await this.getPlots()

      if (
        this.isEditPermissionInvestigate ||
        this.isReadOnlyPermissionInvestigate
      ) {
        await Promise.all([this.getFaultMessages(), this.getUserSelections()])
      }

      if (this.isCustomAlert) {
        await this.getCustomAlertMxRecVersion()
      }
    }
  },

  async beforeDestroy() {
    this.clearTimers()
    this.parentElement.removeEventListener('scroll', this.handlePageScroll)
    window.removeEventListener('resize', this.handlePageResize)
    await this[AC.RESET_ATTACHMENT_ERRORS]()
    await this[MIC.RESET_MX_ERRORS]()
    await this[MIC.RESET_ACTIVE_MXREC]()
    await this[MIC.RESET_CUSTOM_ALERT_MAINTENANCE_ISSUE_VERSION]()
    this[PLC.CANCEL_DASH_SELECTIONS]()
  },

  async destroyed() {
    await this[AC.RESET_ATTACHMENTS]()
  },

  methods: {
    ...mapActions(AC.NAMESPACE, [
      AC.GET_ATTACHMENT,
      AC.GET_ATTACHMENT_TYPES,
      AC.DELETE_ATTACHMENTS,
      AC.CANCEL_ATTACHMENT_UPLOAD,
      AC.SAVE_ATTACHMENT,
      AC.SAVE_REMOVED_ATTACHMENT,
      AC.SAVE_UPDATED_ATTACHMENT,
      AC.RESET_ATTACHMENTS,
      AC.RESET_ATTACHMENT_ERRORS,
    ]),
    ...mapActions(MIC.NAMESPACE, [
      MIC.GET_MAINTENANCE_STATUSES,
      MIC.GET_SINGLE_MAINTENANCE_REC,
      MIC.GET_SESSION_EXPIRATION,
      MIC.GET_FAULT_MESSAGES_DATA,
      MIC.GET_TAGGABLE_USERS,
      MIC.GET_DISCUSSIONS,
      MIC.GET_STATUS_UPDATE,
      MIC.GET_CUSTOM_ALERT_MAINTENANCE_ISSUE_VERSION,
      MIC.UPDATE_CUSTOM_ALERT_MAINTENANCE_ISSUE_VERSION,
      MIC.ADD_DISCUSSION_COMMENT,
      MIC.REMOVE_DISCUSSION_COMMENT,
      MIC.RESET_ACTIVE_MXREC,
      MIC.UPDATE_DISCUSSION_COMMENT,
      MIC.POST_DETAIL_DISCUSSION,
      MIC.UPDATE_DISCUSSIONS,
      MIC.UPDATE_MAINTENANCE_ATTACHMENTS,
      MIC.UPDATE_SINGLE_MAINTENANCE_ISSUE,
      MIC.GET_MAINTENANCE_ISSUE_LOCK_STATUS,
      MIC.SAVE_MAINTENANCE_ISSUE_LOCK_STATUS,
      MIC.GET_SUPPORTING_INFO_SELECTIONS,
      MIC.UPDATE_SUPPORTING_INFO_ROW_SELECTION,
      MIC.SAVE_SUPPORTING_INFO_SELECTIONS,
      MIC.UPDATE_SUPPORTING_INFO_CAPTION,
      MIC.GET_PHM_ALERTS,
      MIC.UPDATE_ATTACHMENT_VISIBILITY,
      MIC.RESET_MX_ERRORS,
      MIC.GET_SEVERITY_OPTIONS,
      MIC.GET_FIX_EFFECTIVENESS_OPTIONS,
      MIC.GET_SERVICE_DELIVERY_OUTCOME_OPTIONS,
      MIC.GET_ANALYTIC_DETECTION_OUTCOME_OPTIONS,
      MIC.GET_REASON_TO_CLOSE_OPTIONS,
      MIC.UPDATE_MXREC_ALERT_DETAILS,
      MIC.UPDATE_MXREC_STATUS_DETAILS,
      MIC.UPDATE_MXREC_VALIDATION_DETAILS,
      MIC.UPDATE_MXREC_CONCLUDE_DETAILS,
      MIC.UPDATE_MXREC_FOLLOWUP_FIELDS,
      MIC.CANCEL_CHANGES,
      MIC.UPDATE_MXREC_RECOMMENDATION,
      MIC.GET_MAINTENANCE_ISSUES_RELATED_ISSUES,
      MIC.UPDATE_MAINTENANCE_ATTACHMENT_CAPTION,
      MIC.GET_ISSUE_SOURCE_OPTIONS,
      MIC.UPDATE_MXREC_TITLE,
      MIC.RESET_CUSTOM_ALERT_MAINTENANCE_ISSUE_VERSION,
    ]),
    ...mapMutations(PLC.NAMESPACE, [PLC.UPDATE_DASH_SELECTIONS]),
    ...mapActions(PLC.NAMESPACE, [
      PLC.CANCEL_DASH_SELECTIONS,
      PLC.SAVE_DASH_SELECTIONS,
      PLC.CREATE_ISSUE_DASH,
      PLC.REPEATER_RELATEDEVENT_GRID_DASH,
    ]),
    ...mapActions(FAC.NAMESPACE, [
      FAC.GET_LAST_UPDATED_DATE,
      FAC.GET_FUTURE_FLIGHT_SCHEDULES,
    ]),

    async getAircraftDetailsData() {
      this.isAircraftDetailsDataLoading = true
      await this[MIC.GET_SINGLE_MAINTENANCE_REC]({ issueId: this.issueId })
      this.issueSource = true
      this[MIC.GET_SEVERITY_OPTIONS]()
      // no need to get these options if you're an updater
      // can't edit those fields
      if (
        this.isEditPermissionInvestigate ||
        this.isReadOnlyPermissionInvestigate
      ) {
        // TODO: check if await is required or we can call the below API in parallel
        await Promise.all([
          this[MIC.GET_FIX_EFFECTIVENESS_OPTIONS](),
          this[MIC.GET_SERVICE_DELIVERY_OUTCOME_OPTIONS](),
          this[MIC.GET_ANALYTIC_DETECTION_OUTCOME_OPTIONS](),
          this[MIC.GET_REASON_TO_CLOSE_OPTIONS](),
        ])
      }
      await this[MIC.GET_ISSUE_SOURCE_OPTIONS]()
      this.isAircraftDetailsDataLoading = false
      this.handleReEntrantLock()
    },

    async getFaultMessages() {
      this.faultMessagesLoading = true
      // default start date to today
      let startDate = moment()
      if (this.mxRec.alerts && this.mxRec.alerts.length) {
        // if there are alerts, start date gets set to the date of the first alert
        startDate = moment(this.mxRec?.alerts[0]?.date)
      }

      let endDate = moment().format('YYYY-MM-DD')
      const currentStatusObj = this.maintenanceStatuses.find(
        status => status.id === this.mxRec?.status?.id,
      )
      if (
        currentStatusObj &&
        currentStatusObj.isExternal &&
        currentStatusObj.isTermial
      ) {
        // if the status is isExternal true && isTermial true then adjust the end date
        // in the query to the date when the status was last updated
        endDate = moment(
          this.mxRec.statusUpdatedOn !== null
            ? this.mxRec.statusUpdatedOn
            : endDate,
        ).format('YYYY-MM-DD')
      }

      const faultMessagesParams = {
        tail: this.mxRec?.tail?.id,
        startDate: startDate.subtract(30, 'days').format('YYYY-MM-DD'),
        endDate: endDate,
      }
      if (this.mxRec?.tail?.id) {
        await this[MIC.GET_FAULT_MESSAGES_DATA](faultMessagesParams)
      }

      this.faultMessagesLoading = false
    },

    async getPhmAlerts() {
      this.phmAlertsLoading = true
      const phmAlertParams = {
        issueId: this.issueId,
      }
      await this[MIC.GET_PHM_ALERTS](phmAlertParams)
      this.phmAlertsLoading = false
    },

    async getUpcomingFlightSchedules() {
      this.upcomingFlightsLoading = true
      await Promise.all([
        this[FAC.GET_LAST_UPDATED_DATE]({
          tail: this.mxRec.tail.name,
          id: this.mxRec.tail.name,
        }),
        this[FAC.GET_FUTURE_FLIGHT_SCHEDULES]({
          tail: this.mxRec.tail.name,
          id: this.mxRec.tail.name,
        }),
      ])
      this.upcomingFlightsLoading = false
    },

    async getAttachments() {
      this.attachmentsLoading = true
      await this[AC.GET_ATTACHMENT_TYPES]()
      this.attachmentsLoading = false
    },

    async getUserSelections() {
      this.userSelectionsLoading = true
      await this[MIC.GET_SUPPORTING_INFO_SELECTIONS](this.issueId)
      this.userSelectionsLoading = false
    },

    async getUserListForDiscussion() {
      this.isDiscussionTypesLoading = true
      await this[MIC.GET_TAGGABLE_USERS]({ issueId: this.issueId })
      this.isDiscussionTypesLoading = false
    },

    async getMxRecDiscussions() {
      await this[MIC.GET_DISCUSSIONS]({ issueId: this.issueId })
    },

    async getMxRecStatusUpdates() {
      await this[MIC.GET_STATUS_UPDATE](this.issueId)
    },

    async getCustomAlertMxRecVersion() {
      await this[MIC.GET_CUSTOM_ALERT_MAINTENANCE_ISSUE_VERSION]({
        issueId: this.issueId,
      })
    },

    async getStatusData() {
      this.isStatusDataLoading = true
      await this[MIC.GET_MAINTENANCE_STATUSES]()
      this.isStatusDataLoading = false
    },

    async getRelatedAlerts() {
      // TODO: for chronic Repeater this should get updated to array of ATA's with source id of chronic repeaters
      const ataData = {
        ataChapter: this.mxRec?.ataChapter,
        tail: this.mxRec?.tail?.id,
        isIssueUpdater: this.isMxRecEditPermission ? true : false,
      }
      this.relatedAlertsLoading = true
      await this[MIC.GET_MAINTENANCE_ISSUES_RELATED_ISSUES](ataData)
      this.relatedAlertsLoading = false
    },

    handleUpdateMxRecStatusDetails(statusData) {
      const isEqual = _isEqual(
        _sortBy({ ...this.getStatusInfo }),
        _sortBy({ ...statusData }),
      )

      if (!isEqual) {
        this.handleIsSaveDisabled(false)
        const selectedStatusOption = this.getStatusOptions.find(
          status => status.id === this.statusId,
        )
        this.updateMxRecStatusDetail({
          ...statusData,
          statusId: this.statusId,
          status: selectedStatusOption || null,
        })
      }
    },

    handleUpdateMxRecStatusID(newStatusId) {
      const selectedStatusOption = this.getStatusOptions.find(
        status => status.id === newStatusId,
      )
      const isEqual = _isEqual(this.statusId, newStatusId)
      if (!isEqual) {
        this.handleIsSaveDisabled(false)
        this.handleMxRecStatusUpdated(true)
        this.updateMxRecStatusDetail({
          ...this.getStatusInfo,
          statusId: newStatusId,
          status: selectedStatusOption || null,
        })
      }
    },

    calculatePreSubmittal() {
      const statusMatch = this.maintenanceStatuses?.find(
        status => status.id === this.mxRec?.status?.id,
      )

      if (statusMatch) {
        if (statusMatch.isExternal) {
          // If postsubmittal
          return false
        } else {
          return true
        }
      } else {
        return true
      }
    },

    handleIsSaveDisabled(isSaveDisabled) {
      this.saveDisabled = isSaveDisabled
    },

    handleMxRecStatusUpdated(mxRecStatusIdChanged) {
      this.statusIdUpdated = mxRecStatusIdChanged
    },

    handleMxRecSeverityUpdated(mxRecSeverityIdChanged) {
      this.severityIdUpdated = mxRecSeverityIdChanged
    },

    handleAttachmentAdded(attachmentUploaded) {
      this.attachmentAdded = attachmentUploaded
    },

    handleCommentRemoval(commentInfo) {
      this[MIC.REMOVE_DISCUSSION_COMMENT](commentInfo)
    },

    async handleDiscussionCommentRemoval(commentInfo) {
      this[MIC.REMOVE_DISCUSSION_COMMENT](commentInfo)

      await this[MIC.UPDATE_DISCUSSIONS]({
        issueId: this.issueId,
        link: window.location.href,
      })

      await this[MIC.GET_DISCUSSIONS]({
        issueId: this.issueId,
        discussionTypeId: this.detailsDiscussionTypeID,
      })
    },

    handleNewComment(commentInfo) {
      // only want to update the store when save is clicked
      if (
        commentInfo &&
        commentInfo.discussionType === this.investigationDiscussionTypeID
      ) {
        this.newInvestigationComment = commentInfo
        this.resetInvestigationComment = false
      }

      if (
        commentInfo &&
        commentInfo.discussionType === this.detailsDiscussionTypeID
      ) {
        this.newDetailsComment = commentInfo
        this.resetDetailsComment = false
      } else this.newDetailsComment = commentInfo
    },

    async handleDetailDiscussionPostClick(comment) {
      if (comment) {
        await this[MIC.POST_DETAIL_DISCUSSION]({
          issueId: this.issueId,
          link: window.location.href,
          ...comment,
        })
        this.resetRecommendationDetailsComment = true
        this.$nextTick(() => {
          this.resetRecommendationDetailsComment = false
        })
      }
    },

    handleRemoveUnsavedComment(comment) {
      if (comment.discussionType === this.investigationDiscussionTypeID) {
        this.newInvestigationComment = null
        this.resetInvestigationComment = false
      }
      if (comment.discussionType === this.detailsDiscussionTypeID) {
        this.newDetailsComment = null
        this.resetDetailsComment = false
      }
    },

    async handleDiscussionCommentUpdate(commentInfo) {
      this.handleUpdateComment(commentInfo)

      await this[MIC.UPDATE_DISCUSSIONS]({
        issueId: this.issueId,
        link: window.location.href,
      })
    },

    handleUpdateComment(commentInfo) {
      if (commentInfo && commentInfo.comment) {
        if (commentInfo.comment.usersTagged.length) {
          let exComment = ''
          let newTaggedUsers = []

          // If its investigation Discussion
          if (
            commentInfo.discussionType === this.investigationDiscussionTypeID &&
            this.preservedMxRec &&
            this.preservedMxRec?.investigationDiscussion
          ) {
            exComment = this.preservedMxRec?.investigationDiscussion.find(
              exComment => exComment.id === commentInfo.comment.id,
            )
          } else {
            // If its details Discussion
            if (
              commentInfo.discussionType === this.detailsDiscussionTypeID &&
              this.preservedMxRec?.detailsDiscussion
            ) {
              exComment = this.preservedMxRec?.detailsDiscussion?.find(
                exComment => exComment.id === commentInfo.comment.id,
              )
            }
          }

          if (exComment && exComment.comment && exComment.comment.length) {
            const previousUsersTagged = Array.from(
              new DOMParser()
                .parseFromString(exComment.comment, 'text/html')
                .getElementsByClassName('mention'),
            ).map(userMention => {
              return Number(userMention.attributes['data-mention-id'].value)
            })

            newTaggedUsers = commentInfo.comment.usersTagged.filter(
              userId => !previousUsersTagged.includes(userId),
            )
            commentInfo.comment.usersTagged = newTaggedUsers
          }
        }
        this[MIC.UPDATE_DISCUSSION_COMMENT](commentInfo)
        this.restoreDiscussions = false
      }
    },

    handleDownloadFile(fileToDownload) {
      this[AC.RESET_ATTACHMENT_ERRORS]()
      this[MIC.RESET_MX_ERRORS]()
      this[AC.GET_ATTACHMENT](fileToDownload)
    },

    async handleMxRecFiles(file) {
      this[AC.RESET_ATTACHMENT_ERRORS]()
      this[MIC.RESET_MX_ERRORS]()
      if (file.fileToSave) {
        this.handleAttachmentAdded(true)
        await this[AC.SAVE_ATTACHMENT](file.fileToSave)
      }
      if (file.remove) {
        this.handleAttachmentAdded(true)
        this.undoAttachmentRemoval = false
        this.showDeleteSupportingAttachmentsConfirmToast = true
        this.attachmentToDelete = this.mxRec.attachments
          .filter(attachment => attachment.id === file.id)
          .pop()
        this[MIC.UPDATE_MAINTENANCE_ATTACHMENTS]({
          remove: true,
          id: file.id,
        })
      }
      if (file.cancel) this[AC.CANCEL_ATTACHMENT_UPLOAD](file.uploadToCancel)
      if (file.update) {
        this[AC.SAVE_UPDATED_ATTACHMENT](file.fileToUpdate)
        this[MIC.UPDATE_ATTACHMENT_VISIBILITY]({
          fileId: file.fileToUpdate.id,
          visibility: file.fileToUpdate.isExternallyVisible,
        })
      }
    },

    scrollToTop() {
      this.intervalId = setInterval(() => {
        if (window.pageYOffset === 0) {
          clearInterval(this.intervalId)
        }
        window.scroll(0, window.pageYOffset - 30)
      }, 20)
    },

    handleInvestigationChanges(status) {
      if (
        !this.mxRecDetailsFormFields.valid &&
        !this.mxRecTitleFormFields.valid &&
        status === 'submit'
      ) {
        // this.showMxRecHeaderAlert = true
        this.manageAlerts({
          type: 'error',
          icon: 'mdi-alert-circle',
          text: 'All required fields must be filled in order to submit.',
          add: true,
          uppercase: true,
        })
        this.scrollToTop()
        return false
      } else {
        const issueDetails = {
          ...this.mxRec,
          ...this.maintenanceActionFollowUpFormData,
          attachmentIds: this.mxRec?.attachments?.map(
            attachment => attachment?.id,
          ),
          maintenanceIssueStatusId: this.statusId,
          recommendation: this.mxRecDetailsFormFields.mxRecDetails,
          updatedDate:
            this.mxRec.updatedDate === null
              ? this.mxRec.createdDate
              : this.mxRec.updatedDate,
          title: this.mxRecTitleFormFields.title,
          issueStatus: status,
        }

        // this is if you are explicity clicking the submit button
        if (status === 'submit') {
          this.handleMxRecSubmitConfirm(issueDetails)
        } else {
          this.handleSaveButtonClicked(issueDetails)
        }
      }
    },

    handleSaveButtonClicked(mxRecDetails) {
      const isPostSubmittal = this.maintenanceStatuses.find(
        status =>
          status.id === mxRecDetails?.maintenanceIssueStatusId &&
          status.isExternal,
      )
      if (this.isSubmitting || this.isMxRecEditPermission) {
        if (isPostSubmittal) {
          this.isPostSubmittalStatus = true
          this.mxRecDetails = mxRecDetails
          this.handleSaveInvestigation(mxRecDetails)
        } else {
          this.mxRecDetails = mxRecDetails
          this.mxRecConfirmSubmitDialogVisibility = true
        }
      } else this.handleSaveInvestigation(mxRecDetails)
    },

    handleMxRecSubmitConfirm(mxRecDetails) {
      this.mxRecDetails = mxRecDetails
      this.mxRecConfirmSubmitDialogVisibility = true
      this.showConfirmationDialog = false
    },
    handleSubmitConfirmDialogClose() {
      this.showConfirmationDialog = false
      this.mxRecConfirmSubmitDialogVisibility = false
      this.mxRecDetails = null
      this.isPostSubmittalStatus = false
      this.statusIdUpdated = false
      this.severityIdUpdated = false
      this.forceSave = false
    },

    handleRowSelected(rowInfo) {
      this[MIC.UPDATE_SUPPORTING_INFO_ROW_SELECTION](rowInfo)
    },

    handleUpdateCaption(captionParams) {
      this[MIC.UPDATE_SUPPORTING_INFO_CAPTION](captionParams)
    },

    handleUpdateAttachmentCaption(attachmentParams) {
      this[MIC.UPDATE_MAINTENANCE_ATTACHMENT_CAPTION](attachmentParams)
    },

    handleDeleteSupportingAttachmentsToastClose() {
      this.showDeleteSupportingAttachmentsConfirmToast = false
      if (!this.undoAttachmentRemoval) {
        this[AC.SAVE_REMOVED_ATTACHMENT](this.attachmentToDelete.id)
      }
    },

    handleUndoDeleteSupportingAttachments() {
      this.undoAttachmentRemoval = true
      this[MIC.UPDATE_MAINTENANCE_ATTACHMENTS]({
        add: true,
        attachments: [this.attachmentToDelete],
      })
      this.showDeleteSupportingAttachmentsConfirmToast = false
    },

    handleUpdateMxRecRecommendation(recommendation) {
      this[MIC.UPDATE_MXREC_RECOMMENDATION](recommendation)
    },

    handleUpdateMxRecAlertDetails(details) {
      this.handleMxRecSeverityUpdated(true)
      this[MIC.UPDATE_MXREC_ALERT_DETAILS](details)
    },

    updateMxRecStatusDetail(details) {
      this[MIC.UPDATE_MXREC_STATUS_DETAILS](details)
    },

    handleUpdateMxRecValidationDetails(details) {
      this[MIC.UPDATE_MXREC_VALIDATION_DETAILS](details)
    },

    handleUpdateMxRecConcludeDetails(details) {
      this[MIC.UPDATE_MXREC_CONCLUDE_DETAILS](details)
    },

    handleUpdateMxRecFollowUpFields(details) {
      this[MIC.UPDATE_MXREC_FOLLOWUP_FIELDS](details)
    },

    handleUpdateMxRecTitle(title) {
      this[MIC.UPDATE_MXREC_TITLE](title)
    },

    async handleUserSaveOnExit() {
      // const isStatus = this.maintenanceStatuses.find(
      //   status => status.id === this.mxRec?.status.id && status.isExternal,
      // )

      this.userConfirmation = true
      if (this.hasData && this.saveDisabled) {
        this.isConfirmation = false
        this.showConfirmationDialog = false
        this.handleDetailDiscussionPostClick(this.postComment)
        this.hasData = false
        this.reRouteUser(this.routePath)
      } else if (
        this.hasData &&
        !this.saveDisabled &&
        (this.isEditPermissionInvestigate || this.isMxRecEditPermission)
      ) {
        this.isConfirmation = false
        this.showConfirmationDialog = false
        this.handleDetailDiscussionPostClick(this.postComment)
        this.hasData = false
        this.forceSave = true
      } else this.forceSave = true
    },
    handleExitWithoutSaving() {
      this.changesMade = false
      this.isPlotlyDirty = false
      this.followUpDataChanges = false
      this.statusIdUpdated = false
      this.attachmentAdded = false
      this.severityIdUpdated = false
      this.hasData = false

      this.reRouteUser(this.routePath)
    },

    handleUserConfirmation() {
      if (
        this.changesMade ||
        this.followUpDataChanges ||
        this.hasData ||
        this.postComment ||
        this.attachmentAdded ||
        this.statusIdUpdated
      ) {
        this.handleSaveUserConfirmation(true)
        this.forceSave = false
        this.hasData = false
        this.changesMade = false
        this.followUpDataChanges = false
        this.attachmentAdded = false
        this.statusIdUpdated = false
        this.severityIdUpdated = false
        if (this.routePath) this.reRouteUser(this.routePath)
      } else {
        this.handleSaveUserConfirmation()
      }
    },

    async handleSaveUserConfirmation(postSaveExistConfirmed = false) {
      if (
        this.changesMade ||
        this.followUpDataChanges ||
        this.hasData ||
        this.postComment ||
        this.attachmentAdded ||
        this.statusIdUpdated
      ) {
        postSaveExistConfirmed = true
        this.forceSave = false
        this.hasData = false
        this.changesMade = false
        this.followUpDataChanges = false
        this.attachmentAdded = false
        this.statusIdUpdated = false
      }
      this.isPostSubmittalStatus = false
      this.userConfirmation = true
      this.isSubmitting = true
      this.statusIdUpdated = false
      this.severityIdUpdated = false

      // Is user selected status is a pre-submittal statuses
      const selectedStatusOption = this.getStatusOptions.find(
        status => status.id === this.mxRecDetails.maintenanceIssueStatusId,
      )

      // If selected status is a Presubmittal
      if (!selectedStatusOption.isExternal) {
        // If isExternal is true && isInitial is true === MxRecAvailable  === Maintenance Rec Submitted === New Mx Rec
        const mxRecAvailableStatus = this.getStatusOptions.find(
          status => status.isExternal && status.isInitial,
        )

        // If you're on a pre-submittal status, when you're submitting,
        // set the statusto the mx rec available status
        this.mxRecDetails.maintenanceIssueStatusId = mxRecAvailableStatus.id
        this.mxRecDetails.dateSubmitted = new Date()
      }

      await this.handleSaveInvestigation(
        this.mxRecDetails,
        postSaveExistConfirmed,
      )
      await this.clearTimers()
      // Release lock if its already aquired
      if (this.reEntrantLockObtained) this.handleReEntrantLock(false)
    },

    async handleUserRenew() {
      this.userTimer(true)
      this.routePath = null
      this.isConfirmation = false
      this.userConfirmation = false
      this.showConfirmationDialog = false
      this.resetRecommendationDetailsComment = false
      // Already have a lock then renew it
      if (this.reEntrantLockObtained) this.handleReEntrantLock()
    },

    async handleSaveInvestigation(mxRecInfo, postSaveExistConfirmed = false) {
      this.forceSave = false
      this.showConfirmationDialog = false
      if (mxRecInfo) {
        if (this.newInvestigationComment) {
          this[MIC.ADD_DISCUSSION_COMMENT](this.newInvestigationComment)
          this.newInvestigationComment = null
          this.resetInvestigationComment = true
        }

        if (
          this.postComment?.comment?.comment !== '' &&
          this.postComment?.comment?.comment !== '<p></p>' &&
          this.postComment &&
          postSaveExistConfirmed
        ) {
          this[MIC.ADD_DISCUSSION_COMMENT](this.postComment)
          this.postComment = null
          this.resetRecommendationDetailsComment = true
          this.$nextTick(() => {
            this.resetRecommendationDetailsComment = false
          })
        }

        this[AC.RESET_ATTACHMENT_ERRORS]()
        this[MIC.RESET_MX_ERRORS]()
        this.isSaveLoading = true
        delete mxRecInfo.issueStatus
        // add in the issue id so we know which one we're saving
        const mxRecToSave = {
          ...mxRecInfo,
          id: this.issueId,
          aircraftId: mxRecInfo.tail.id,
        }
        // if ownerUserId is an array, get the imteger for it (it will be the first item)
        if (Array.isArray(mxRecToSave.ownerUserId)) {
          mxRecToSave.ownerUserId = mxRecToSave.ownerUserId[0]
        }

        const promises = [
          this.attachmentsToRemove.length
            ? this[AC.DELETE_ATTACHMENTS](this.attachmentsToRemove)
            : Promise.resolve(null),
          this.attachmentsToUpdate.length
            ? this[AC.SAVE_ATTACHMENT](this.attachmentsToUpdate)
            : Promise.resolve(null),
          // you can only save supporting info selections as an
          // issue investigator
          this.isEditPermissionInvestigate
            ? this[MIC.SAVE_SUPPORTING_INFO_SELECTIONS](this.issueId)
            : Promise.resolve(null),
          this[MIC.UPDATE_DISCUSSIONS]({
            issueId: this.issueId,
            link: window.location.href,
          }),
          this[AC.RESET_ATTACHMENTS](),
          this.dashSelections && this.isPlotlyDirty
            ? await this[PLC.SAVE_DASH_SELECTIONS]({
                selections: this.dashSelections,
                issueId: this.issueId,
              })
            : Promise.resolve(null),
          this[MIC.UPDATE_SINGLE_MAINTENANCE_ISSUE](mxRecToSave),
        ]

        const saves = await Promise.all(
          promises.map(p => p?.catch(error => error)),
        )
        const noErrors = saves.filter(result => !(result instanceof Error))

        if (noErrors.length === promises.length) {
          this.getMxRecStatusUpdates()
          this.changesMade = false
          this.followUpDataChanges = false
          this.isPlotlyDirty = false
          this.showConfirmationDialog = false
          this.attachmentAdded = false
          this.severityIdUpdated = false
          this.statusIdUpdated = false
          this.hasData = false
          this.isConfirmation = false
          this.postComment = false
          this.hasData = false

          // Re-render plotly component
          this.$nextTick(() => {
            this.isPlotlyDirty = true
            this.reRenderPlotly = true
          })
          this.$nextTick(() => {
            this.isPlotlyDirty = false
            this.reRenderPlotly = false
          })

          // only if the action is submit do you change
          // submit success to
          if (this.isSubmitting) {
            this.isSubmitting = false
            this.isSaveLoading = false
          } else {
            this.isSaveLoading = false
            this.showConfirmationDialog = false
          }
          // pre-post submittal status check should
          // only be done post save or submit
          if (this.userConfirmation && this.routePath) {
            this.reRouteUser(this.routePath)
          }
        } else {
          this.forceSave = false
          this.isSubmitting = false
          this.isSaveLoading = false
          this.handleUserRenew()
        }
      }
    },

    handleCancelChanges() {
      this[MIC.CANCEL_CHANGES]()
      this[PLC.CANCEL_DASH_SELECTIONS]()
      this.resetDetailsComment = true // Reset/Clear comment fields
      this.resetInvestigationComment = true
      this.restoreDiscussions = true
      this[AC.RESET_ATTACHMENTS]()
      this.saveDisabled = true
      this.followUpDataChanges = false
      this.attachmentAdded = false
      this.statusIdUpdated = false
      this.severityIdUpdated = false
      this.reRenderPlotly = true
      this.$nextTick(() => {
        this.isPlotlyDirty = false
        this.resetDetailsComment = false
        this.reRenderPlotly = false
      })
    },

    async reRouteUser(route) {
      await this.$router.push(route.path).catch(err => {
        throw new Error(`Problem navigating: ${err}.`)
      })
    },

    // SCROLL EVENTS
    getElementOffset(element) {
      const rect = element.getBoundingClientRect()
      const scrollTop = this.parentElement.scrollTop
      const scrollLeft = this.parentElement.scrollLeft
      const clientTop = this.parentElement.clientTop || 0
      const clientLeft = this.parentElement.clientLeft || 0

      return {
        top: rect.top + scrollTop - clientTop,
        left: rect.left + scrollLeft - clientLeft,
        width: rect.width,
        height: rect.height,
      }
    },

    handlePageScroll() {
      const scrollTop = this.parentElement.scrollTop
      const elementOffset = this.getElementOffset(this.$el)
      const offsetDifference = elementOffset.top + 1

      if (offsetDifference <= scrollTop && !this.isSticky) {
        this.isSticky = true
      } else if (offsetDifference > scrollTop && this.isSticky) {
        this.isSticky = false
      }
    },

    handlePageResize() {
      this.isSticky = false
      this.$nextTick(() => {
        this.handlePageScroll()
      })
    },

    // Use for session timeout
    clearTimers() {
      if (this.sessionTimer && this.warningTimer) {
        this.timeIsUp = false
        clearInterval(this.sessionTimer)
        clearInterval(this.warningTimer)
      }
    },

    async userTimer(start) {
      await this.clearTimers()
      if (start) {
        const warningConfirmation = moment.duration(50, 'm')
        const reRouteDuration = moment.duration(60, 'm')
        this.warningTimer = setInterval(() => {
          this.isConfirmation = false
          this.showConfirmationDialog = true
          this.routePath = { path: '/maintenance' }
        }, warningConfirmation)
        this.sessionTimer = setInterval(() => {
          this.timeIsUp = true
          this[MIC.GET_SESSION_EXPIRATION](true)
          if (this.reEntrantLockObtained) this.handleReEntrantLock(false)
          this.reRouteUser({ path: '/maintenance' })
        }, reRouteDuration)
      }
    },

    async issueLock(setLock) {
      const lockStatus = await this[MIC.SAVE_MAINTENANCE_ISSUE_LOCK_STATUS]({
        issueId: this.issueId,
        setLock: setLock,
      })

      if (lockStatus) {
        if (setLock) {
          this.reEntrantLockObtained = true
        } else {
          this.reEntrantLockObtained = null
        }
      } else {
        this.reEntrantLockObtained = false
      }
    },

    async handleReEntrantLock(setLock = true) {
      if (!this.isReadOnlyPermissionInvestigate) {
        const currentStatus = await this[MIC.GET_MAINTENANCE_ISSUE_LOCK_STATUS](
          {
            issueId: this.issueId,
          },
        )

        if (!currentStatus?.lockObtained && setLock) {
          if (
            currentStatus.reason ===
            'This maintenance issue is not currently locked'
          )
            this.issueLock(setLock)

          if (
            currentStatus.reason ===
            'Another user is currently editting this maintenance issue'
          ) {
            this.lockedBy = currentStatus.lockedBy
            this.reEntrantLockObtained = false
          }
        } else {
          if (!setLock) this.issueLock(setLock)
          else {
            // Lock has already been obtained
            this.reEntrantLockObtained = true
          }
        }
      }
    },

    isPostData(data) {
      this.hasData = data
    },

    getCommentText(data) {
      this.postComment = data
    },

    hasFollowUpDataChanges(data) {
      this.followUpDataChanges = data
    },

    manageAlerts(alertItem) {
      const alertColor =
        alertItem.type === 'success' ? 'primary' : alertItem.type

      const alert = {
        color: alertColor,
        dismissible: false,
        isActive: true,
        mode: 'alert',
        type: alertItem.type || '',
        text: alertItem.text || '',
        icon: alertItem.icon || null,
        add: alertItem.add || '',
        uppercase: alertItem.uppercase || false,
      }

      const existingAlert = this.definition
        .filter(item => item.text === alert.text)
        .pop()

      if (alertItem.add) {
        if (!existingAlert) this.definition.push(alert)
      } else {
        this.definition = this.definition.filter(
          item => item.text !== alert.text,
        )
      }
    },

    handleViewMxRecAction() {
      const issueId =
        this.customAlertMaintenanceIssueVersion.relatedCustomAlertIssueId
      const sanitizedIssueId = encodeURIComponent(issueId)
      this.$router.push({
        name: 'Mx Recs',
        params: {
          issueId: sanitizedIssueId,
        },
      })
    },

    handleRelatedEventGridChange(data) {
      if(Array.isArray(data) && data.length> 0){
        this[PLC.UPDATE_DASH_SELECTIONS](data)
        this.saveDisabled = false
        this.isPlotlyDirty = true
      }
      
    },

    handleRepeaterRelatedEventGridChange(data) {
      this[PLC.REPEATER_RELATEDEVENT_GRID_DASH](data).then(() => {
        this.getAircraftDetailsData()
        this.getMxRecStatusUpdates()
      })
    },

    getSafeIssueRoute(id) {
      const validRouteNames = ['Mx Recs']
      const routeName = 'Mx Recs'
      const intId = parseInt(id)
      if (validRouteNames.includes(routeName)) {
        const routeUrl = this.$router.resolve({
          name: routeName,
          params: {
            issueId: intId,
          },
        })
        return new URL(routeUrl.href, window.location.origin).href
      }
      throw new Error('Invalid route name provided')
    },

    handleOnIssueCreation(data) {
      this.isIssueCreationInprogres = true

      const tailNumber = encodeURIComponent(this.mxRec.tail.name)
      const issueCreated = this[PLC.CREATE_ISSUE_DASH]({
        selections: data,
        tail: tailNumber,
      })

      const newTab = window.open('', '_blank')
      const routeUrl = this.getSafeIssueRoute(-1)
      newTab.location.replace(routeUrl)
      issueCreated
        .then(issue => {
          if (issue) {
            this.addNewRepeaterIssueDialogVisible = false
            const routeUrl = this.getSafeIssueRoute(issue.data.id)
            newTab.location.replace(routeUrl)
          }
        })
        .catch(err => {
          console.error('Issue creation failed:', err)
        })
        .finally(() => {
          setTimeout(() => {
            this.getAircraftDetailsData()
            this.getMxRecStatusUpdates()
            this.isIssueCreationInprogres = false
            this.isPlotlyDirty = true
            this.reRenderPlotly = true
            this.$nextTick(() => {
              this.isPlotlyDirty = false
              this.reRenderPlotly = false
            })
          }, 4000)
        })
    },
  },
}
</script>

<style lang="scss">
.asc-issue-investigation-container {
  &__card {
    .v-tab::before {
      background-color: initial;
    }

    .issueReaderUpdatedWrap {
      position: absolute;
      right: calc(0% + 16px);
      top: 25%;

      span {
        color: $gray-700;
      }
    }

    .updatedDate {
      color: $gray-800;
      font-size: 12px;
      letter-spacing: 0;
      border-bottom: 1px solid $gray-300;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      height: 43px;
    }
  }

  .asc-tab__content--primary {
    padding: 0;

    a {
      color: $accent-700;
      text-decoration: none;

      .v-icon {
        color: inherit;
      }
    }
  }
}
</style>
